module.exports = __webpack_public_path__ + "img/logo.0c48b7d6.png";